export default "__VITE_ASSET__C8J2kRhM__"